import { Icon as CroplerIcon } from '@cropler/ui-kit';
import styles from './styles.module.scss';

const ImageBoxModal = ({ imageUrl, alt = 'Cropler', showMask = false, maskUrl = null }) => {
  return (
    <>
      <div className={styles.imageFullModal}>
        {imageUrl ? (
          <div className={styles.imageFullModalWrapper}>
            <img src={imageUrl} alt={alt} />
            {showMask && maskUrl && <img className={styles.imageFullModalMask} src={maskUrl} alt="" />}
          </div>
        ) : (
          <CroplerIcon name="cropler" />
        )}
      </div>
    </>
  );
};

export default ImageBoxModal;
